import { useMemo } from 'react'
import { Divider } from '@mui/material'
import { MenuIcon } from '$common/icons/menu'
import { AddUserIcon } from '$common/icons'
import {
  UserListItemSkeleton,
  UserListItemWithStatus,
} from '$common/user-list-item'
import { EmptyStateList } from '$common/empty-state-list'
import { withSearchableListPage } from '$common/searchable-list-page'
import {
  useClientUserPermissions,
  useGroupExceptionMembers,
  useSearchedGroupExceptionMembers,
} from '$logic/subscription/react-hook'
import {
  closeGroupExceptions,
  openAddGroupExceptionMember,
} from '$logic/router'
import { showGroupExceptionUserMenu } from '$comp/modals/menus/group-exception-user-menu'
import { t } from '$i18n'

const ListItem = ({ id, roomId }: { id: string; roomId: string }) => (
  <>
    <UserListItemWithStatus
      userId={id}
      hasDivider={false}
      onClick={() => {
        showGroupExceptionUserMenu({ userId: id, roomId })
      }}
      SecondaryActionIcon={MenuIcon}
      onSecondaryActionIconClick={() => {
        showGroupExceptionUserMenu({ userId: id, roomId })
      }}
    />
    <Divider variant="inset" />
  </>
)

export function GroupExceptionUsers({ roomId }: { roomId: string }) {
  const clientUserPermissions = useClientUserPermissions(roomId)

  const Page = useMemo(
    () =>
      withSearchableListPage<
        { id: string },
        string,
        { hallId: string; query: string; fetchedItems: { id: string }[] }
      >({
        appBarTitle: t('settings.privacy.exception.set'),
        ListItem: item => <ListItem id={item.id} roomId={roomId} />,
        SkeletonItem: UserListItemSkeleton,
        EmptyStateComponent: () => <EmptyStateList />,
        fetchHook: useGroupExceptionMembers,
        searchHook: useSearchedGroupExceptionMembers,
        actionButtons: [
          {
            text: t('settings.privacy.exception.add'),
            icon: <AddUserIcon color="secondary" />,
            onClick: () => openAddGroupExceptionMember(roomId),
          },
        ],
        subHeaderText: t('settings.privacy.exception.exceptions'),
        onBack: closeGroupExceptions,
      }),
    [roomId, clientUserPermissions?.isOwner],
  )

  return (
    <Page
      fetchHookParams={roomId}
      getSearchHookParams={(query, items) => ({
        query,
        fetchedItems: items,
        hallId: roomId,
      })}
      hideActionButton={!clientUserPermissions?.isOwner}
    />
  )
}
